import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { formatDZ } from '../../../utils/currency';

const RecommendedItems = ({ recommendedItems, onAddToCart }) => {
  if (recommendedItems?.length === 0) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold command-text">Recommended for You</h2>
        <Link 
          to="/category-pages"
          className="text-sm text-primary hover:text-primary/80 transition-colors"
        >
          View All
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {recommendedItems?.map((item) => (
          <div key={item?.id} className="holographic-card p-4 rounded-lg group">
            <div className="space-y-4">
              {/* Product Image */}
              <div className="aspect-square rounded-lg overflow-hidden bg-muted/20 relative">
                <Image
                  src={item?.image}
                  alt={item?.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {item?.isNew && (
                  <div className="absolute top-2 left-2 bg-accent text-accent-foreground px-2 py-1 rounded-full text-xs font-medium">
                    New
                  </div>
                )}
                {item?.discount && (
                  <div className="absolute top-2 right-2 bg-error text-error-foreground px-2 py-1 rounded-full text-xs font-medium">
                    -{item?.discount}%
                  </div>
                )}
              </div>

              {/* Product Info */}
              <div className="space-y-2">
                <Link 
                  to={`/product/${item?.id}`}
                  className="font-semibold text-foreground hover:text-primary transition-colors line-clamp-2 text-sm"
                >
                  {item?.name}
                </Link>
                
                {/* Rating */}
                <div className="flex items-center space-x-2">
                  <div className="flex items-center space-x-1">
                    {[...Array(5)]?.map((_, i) => (
                      <Icon
                        key={i}
                        name="Star"
                        size={14}
                        className={i < Math.floor(item?.rating) ? 'text-accent fill-current' : 'text-muted-foreground'}
                      />
                    ))}
                  </div>
                  <span className="text-xs text-muted-foreground">
                    ({item?.reviews})
                  </span>
                </div>

                {/* Price */}
                <div className="flex items-center space-x-2">
                  <span className="text-lg font-bold text-primary">
                    {formatDZ(item?.price)}
                  </span>
                  {item?.originalPrice && item?.originalPrice > item?.price && (
                    <span className="text-sm text-muted-foreground line-through">
                      {formatDZ(item?.originalPrice)}
                    </span>
                  )}
                </div>
              </div>

              {/* Add to Cart Button */}
              <Button
                variant="outline"
                size="sm"
                onClick={() => onAddToCart(item?.id)}
                className="w-full group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
              >
                <Icon name="Plus" size={16} className="mr-2" />
                Add to Cart
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendedItems;